<div class="flex gap-1">
  <span>{{ value() }}</span>

  @if (unit(); as unit) {
    <span>{{ unit }}</span>
  }
</div>
